export const ORDER_TRANSLATIONS = {
  en: {
    hi: 'Hi',
    welcome: 'Welcome',
    weAreExcited: 'We are so excited to have you as a riise member. Ready to be more?',
    coFounders: 'Co-founders of Riise',
    weChoose1: 'We chose not to add any artificial flavors, ',
    weChoose2: 'the strong taste comes from the pure ingredients.',
    weChoose3: 'Take it with water or on yogurt.',
    yourRiise: 'Your Riise',
    contains: 'Contains',
    ingredients: 'ingredients',
    topFocusAreas: 'Your top focus areas',
    topFocusAreasDesc: 'You can change them anytime from your health dashboard.',
    nutrient: 'Nutrient',
    dailyDose: 'Daily Dose',
    unit: 'Unit',
    ourExpertCommittee:
      'Our expert committee recommends a minimum of three months to have the best results from supplementation.',
    howToTakeHeading: 'How to take your daily riise?',
    howToTakeStep1Heading: 'Directly into your mouth with water',
    howToTakeStep1Desc: 'Pour your pouch directly into your mouth and follow with water.',
    howToTakeStep2Heading: 'Mixed in food',
    howToTakeStep2Desc: 'Add your granules to yogurt or a bowl.',
    howToTakeStep3Heading: 'With juice for taste',
    howToTakeStep4Desc: 'If you are sensitive to taste, mix your granules with fruit juice.',
    donotCrunch: "Don't crunch—swallow the granules for best absorption and experience!",
    alwaysTakeRiise: 'Always take riise with a meal; it helps absorption and is gentler on your stomach.',
    needToSee: 'Need to see more about how to take riise?',
    seeOurExplanation: 'See our explanation video:',
    checkInEveryDay: 'Make sure to check in every day. Earn points while we improve your formula.',
    checkInEveryDayDesc:
      'On your sachets, scan the QR code and answer the question. We can improve the recipe for your unique body and how it reacts. You can also take the test again if something changes in your life.',
    whatNow: 'What now?',
    whatNowDesc:
      'We want Riise to become an ode to a free, intense, and joyful life. Get the most out of it—talk with health experts on the platform.',
    recommend: 'Recommend to your friends',
    shareRefferalCode: 'Share your referral code.',
    discount: '15% off the 1st month for your friend',
    anyQuestions: 'Any questions?',
    weAnswerFast: 'We answer fast at:',
    yourCode: 'Your code is in your dashboard',
    productName: 'Product name',
    netQuantity: 'Net quantity',
    ingredientsDesc:
      'Sucrose (core component of the microgranules), starch (core component of the microgranules), hydroxypropyl methylcellulose (E464 – outer protective layer of each microgranule)',
    instructionsForUse: 'Instructions for use',
    instructionsForUseDesc:
      'Take one sachet daily. You can take it directly with some water, or sprinkle it on yogurt or food.',
    allergyInformation: 'Allergy information',
    allergyInformationDesc:
      'This product does not contain any of the most common allergens. People with allergies or intolerances should consult their doctor before use.',
    warnings: 'Warnings',
    warningsDesc:
      'Food supplements are not a substitute for a balanced and varied diet and a healthy lifestyle. Do not exceed the recommended daily dose. Keep out of the reach of small children. If pregnant, breastfeeding, ill or taking medication, consult a doctor before use.',
    storageInstructions: 'Storage instructions',
    storageInstructionsDesc: 'Store in a cool, dry place. Protect from direct sunlight and heat.',
    preparationDate: 'Preparation date',
    bestBeforeDate: 'Best before date',
    manufacturerInformation: 'Manufacturer information',
    countryOfManufacture: 'Country of manufacture',
    countryOfManufactureDesc: 'Made in Germany',
    customerService: 'Customer service',
    customerServiceDesc: 'Contact us at hi@weriise.co',
    batchNumber: 'Batch number',
    ingredient: 'Ingredient',
    amountPerB: 'Amount per bag',
    amountPerBag: 'Amount per bag',
    referenceQuantity: 'Reference quantity',
    energy: 'Energy',
    fat: 'Fat',
    saturatedFattyAcids: 'Saturated fatty acids',
    carbohydrates: 'Carbohydrates',
    sugar: 'Sugar',
    protein: 'Protein',
    salt: 'Salt',
    nutritionalValues: 'NUTRITIONAL VALUES PER BAG',
    nutritionalInfo: 'NUTRITIONAL INFORMATION',
    nutrientAmountNrv: '(Nutrient • Amount • % NRV)',
  },
  de: {
    hi: 'Hallo',
    welcome: 'Willkommen',
    weAreExcited: 'Wir freuen uns sehr, Sie als Riise-Mitglied begrüßen zu dürfen. Bereit für mehr?',
    coFounders: 'Mitgründer von Riise',
    weChoose1: 'Wir haben uns entschieden, keine künstlichen Aromen hinzuzufügen. ',
    weChoose2: 'Der kräftige Geschmack stammt aus den reinen Inhaltsstoffen. ',
    weChoose3: 'Nehmen Sie es mit Wasser oder auf Joghurt ein.',
    yourRiise: 'Ihr Riise',
    contains: 'Enthält',
    ingredients: 'Zutaten',
    topFocusAreas: 'Ihre wichtigsten Fokusbereiche',
    topFocusAreasDesc: 'Sie können diese jederzeit in Ihrem Gesundheits-Dashboard ändern.',
    nutrient: 'Nährstoff',
    dailyDose: 'Tagesdosis',
    unit: 'Einheit',
    ourExpertCommittee:
      'Unser Expertengremium empfiehlt mindestens drei Monate, um die besten Ergebnisse durch die Supplementierung zu erzielen.',
    howToTakeHeading: 'Wie nehmen Sie Ihr tägliches Riise ein?',
    howToTakeStep1Heading: 'Direkt in den Mund mit Wasser',
    howToTakeStep1Desc: 'Gießen Sie Ihren Beutel direkt in den Mund und trinken Sie etwas Wasser nach.',
    howToTakeStep2Heading: 'Mit Nahrung gemischt',
    howToTakeStep2Desc: 'Fügen Sie Ihre Granulate einem Joghurt oder einer Schüssel hinzu',
    howToTakeStep3Heading: 'Mit Saft für den Geschmack',
    howToTakeStep4Desc:
      'Wenn Sie empfindlich auf den Geschmack reagieren, mischen Sie Ihre Granulate mit Fruchtsaft.',
    donotCrunch: 'Nicht zerkauen, schlucken Sie die Granulate für die beste Aufnahme und Erfahrung!',
    alwaysTakeRiise:
      'Nehmen Sie Riise immer zu einer Mahlzeit ein, das unterstützt die Aufnahme und schont den Magen.',
    needToSee: 'Möchten Sie mehr darüber sehen, wie man Riise einnimmt?',
    seeOurExplanation: 'Sehen Sie sich unser Erklärvideo an:',
    checkInEveryDay:
      'Vergessen Sie nicht, täglich einzuchecken. Sammeln Sie Punkte, während wir Ihre Formel verbessern.',
    checkInEveryDayDesc:
      'Scannen Sie den QR-Code auf Ihren Portionen und beantworten Sie die Fragen. So können wir die Rezeptur an Ihren Körper und dessen Reaktionen anpassen. Sie können den Test auch wiederholen, falls sich in Ihrem Leben etwas ändert.',
    whatNow: 'Was jetzt?',
    whatNowDesc:
      'Wir möchten, dass Riise zu einer Ode an ein freies, intensives und freudiges Leben wird. Nutzen Sie es bestmöglich und sprechen Sie mit Gesundheitsexperten auf der Plattform.',
    recommend: 'Empfehlen Sie uns Ihren Freunden',
    shareRefferalCode: 'Teilen Sie Ihren Empfehlungscode.',
    discount: '15 % Rabatt im 1. Monat für Ihren Freund',
    anyQuestions: 'Haben Sie Fragen?',
    weAnswerFast: 'Wir antworten schnell unter:',
    yourCode: 'Ihr Code befindet sich in Ihrem Dashboard',
    productName: 'Produktname',
    netQuantity: 'Nettofüllmenge',
    ingredientsDesc:
      'Saccharose (Kernbestandteil der Mikrogranulate), Stärke (Kernbestandteil der Mikrogranulate), Hydroxypropylmethylcellulose (E464 - Äußere Schutzschicht jedes Mikrogranulats)',
    instructionsForUse: 'Hinweise zur Einnahme',
    instructionsForUseDesc:
      'Nehmen Sie täglich einen Beutel. Sie können ihn pur einnehmen und dazu etwas Wasser trinken, oder auf Joghurt oder Essen streuen',
    allergyInformation: 'Allergiehinweise',
    allergyInformationDesc:
      'Dieses Produkt enthält keine der häufigsten Allergene. Personen mit Allergien oder Unverträglichkeiten sollten vor der Verwendung ihren Arzt konsultieren.',
    warnings: 'Warnhinweise',
    warningsDesc:
      'Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene und abwechslungsreiche Ernährung und eine gesunde Lebensweise. Die empfohlene Tagesdosis darf nicht überschritten werden. Außerhalb der Reichweite von kleinen Kindern aufbewahren. Bei Schwangerschaft, Stillzeit, Krankheiten oder Medikamenteneinnahme vor der Verwendung einen Arzt konsultieren.',
    storageInstructions: 'Aufbewahrungshinweise',
    storageInstructionsDesc: 'Kühl und trocken lagern. Vor direkter Sonneneinstrahlung und Wärme schützen.',
    preparationDate: 'Herstellungsdatum',
    bestBeforeDate: 'Mindesthaltbarkeitsdatum',
    manufacturerInformation: 'Herstellerinformationen',
    countryOfManufacture: 'Herstellungsland',
    countryOfManufactureDesc: 'Hergestellt in Deutschland',
    customerService: 'Kundenservice',
    customerServiceDesc: 'Kontaktieren Sie uns unter hi@weriise.co',
    batchNumber: 'Chargennummer',
    ingredient: 'Inhaltsstoff',
    amountPerB: 'Menge pro B.',
    amountPerBag: 'Menge pro Beutel',
    referenceQuantity: 'Referenzmenge',
    energy: 'Energie',
    fat: 'Fett',
    saturatedFattyAcids: 'Gesättigte Fettsäuren',
    carbohydrates: 'Kohlenhydrate',
    sugar: 'Zucker',
    protein: 'Eiweiß',
    salt: 'Salz',
    nutritionalValues: 'NÄHRWERTE PRO BEUTEL',
    nutritionalInfo: 'NÄHRWERTTABELLE',
    nutrientAmountNrv: '(Nährstoff • Menge • % NRV)',
  },
};

export const EXTERNAL_ORDER_TRANSLATIONS = {
  en: {
    hi: 'Hi',
    welcome: 'Welcome',
    weAreExcited: 'We are so excited for you to start your new custom supplement routine!',
    yourDailyFormula: 'Your daily formula',
    nutrient: 'Nutrient',
    dailyDose: 'Daily Dose',
    unit: 'Unit',
    our: 'Our',
    ingredients: 'ingredients',
    expertCommittee: 'expert committee',
    ourExpertCommittee: 'recommends a minimum of three months to have the best results from supplementation.',
    artificialFlavours: 'We chose not to add artificial flavors: take it with water or on yogurt.',
    startNewHabbit: 'Start new habits: take your dose daily.',
    startNewHabbitDesc: 'If you forget one day, do not take the dose twice the next day—continue as usual.',
    howToTakeHeading: 'How to take your daily dose?',
    howToTakeDesc: 'Take your daily dose with a meal—any meal—to ensure optimal nutrient absorption!',
    howToTakeDesc2: 'Our favorite ways to take your daily sachet:',
    howToTakeStep1Heading: 'Directly into your mouth with water',
    howToTakeStep1Desc: 'Put the pellets in your mouth, followed by sips of water.',
    howToTakeStep2Heading: 'Mixed in food',
    howToTakeStep2Desc: 'Add it to food—sprinkle it on yogurt or your morning bowl.',
    howToTakeStep3Heading: 'With juice for taste',
    howToTakeStep3Desc: 'With your favorite fruit juice!',
    anyQueries: 'Do you have any questions? We answer fast at:',
    //New values
    productName: 'Product Name',
    netQuantity: 'Net Quantity',
    ingredientsDesc:
      'Sucrose (core component of the microgranules), starch (core component of the microgranules), hydroxypropyl methylcellulose (E464 – outer protective layer of each microgranule)',
    instructionsForUse: 'Instructions for Use',
    instructionsForUseDesc:
      'Take one sachet daily. You can take it directly with some water, or sprinkle it over yogurt or food.',
    allergyInformation: 'Allergy Information',
    allergyInformationDesc:
      'This product does not contain any of the common allergens. People with allergies or intolerances should consult their doctor before use.',
    warnings: 'Warnings',
    warningsDesc:
      'Food supplements are not a substitute for a balanced and varied diet and a healthy lifestyle. The recommended daily dose should not be exceeded. Keep out of reach of small children. Consult a doctor before use during pregnancy, breastfeeding, illness, or medication intake.',
    storageInstructions: 'Storage Instructions',
    storageInstructionsDesc: 'Store in a cool, dry place. Protect from direct sunlight and heat.',
    bestBeforeDate: 'Best Before Date',
    manufacturerInformation: 'Manufacturer Information',
    countryOfManufacture: 'Country of Manufacture',
    countryOfManufactureDesc: 'Made in Germany',
    customerService: 'Customer Service',
    customerServiceDesc: 'Contact us at hello@gettested.io',
    batchNumber: 'Batch number',
    ingredient: 'Ingredient',
    amountPerB: 'Amount per bag',
    amountPerBag: 'Amount per bag',
    referenceQuantity: 'Reference quantity',
    energy: 'Energy',
    fat: 'Fat',
    saturatedFattyAcids: 'Saturated fatty acids',
    carbohydrates: 'Carbohydrates',
    sugar: 'Sugar',
    protein: 'Protein',
    salt: 'Salt',
    nutritionalValues: 'NUTRITIONAL VALUES PER BAG',
    nutritionalInfo: 'NUTRITIONAL INFORMATION',
    nutrientAmountNrv: '(Nutrient • Amount • % NRV)',
  },
  de: {
    hi: 'Hallo',
    welcome: 'Willkommen',
    weAreExcited: 'Wir freuen uns sehr, dass du mit deiner neuen individuellen Supplement-Routine beginnst!',
    yourDailyFormula: 'Deine tägliche Formel',
    nutrient: 'Nährstoff',
    dailyDose: 'Tagesdosis',
    unit: 'Einheit',
    our: 'Unser',
    ingredients: 'Zutaten',
    expertCommittee: 'Expertengremium',
    ourExpertCommittee:
      'empfiehlt mindestens drei Monate, um die besten Ergebnisse durch Supplementierung zu erzielen.',
    artificialFlavours:
      'Wir haben uns entschieden, keine künstlichen Aromen hinzuzufügen: nimm es mit Wasser oder mit Joghurt.',
    startNewHabbit: 'Beginne neue Gewohnheiten, nimm deine Dosis täglich.',
    startNewHabbitDesc:
      'Wenn du einen Tag vergisst, nimm die Dosis nicht doppelt am nächsten Tag, sondern mache wie gewohnt weiter.',
    howToTakeHeading: 'Wie nimmst du deine tägliche Dosis ein?',
    howToTakeDesc:
      'Nimm deine Tagesration mit einer Mahlzeit – egal welcher – um eine optimale Nährstoffaufnahme zu gewährleisten!',
    howToTakeDesc2: 'Unsere Lieblingsarten, deine tägliche Portion einzunehmen:',
    howToTakeStep1Heading: 'Direkt in den Mund mit Wasser',
    howToTakeStep1Desc: 'Pellets in den Mund geben und mit Wasser nachspülen',
    howToTakeStep2Heading: 'Mit Essen gemischt',
    howToTakeStep2Desc: 'Mit Essen vermischen, z. B. in Joghurt oder deine Frühstücksschale geben',
    howToTakeStep3Heading: 'Mit Saft für den Geschmack',
    howToTakeStep3Desc: 'Mit deinem Lieblingsfruchtsaft!',
    anyQueries: 'Hast du Fragen? Wir antworten schnell unter:',
    // New Values
    productName: 'Produktname',
    netQuantity: 'Nettofüllmenge',
    ingredientsDesc:
      'Saccharose (Kernbestandteil der Mikrogranulate), Stärke (Kernbestandteil der Mikrogranulate), Hydroxypropylmethylcellulose (E464 - Äußere Schutzschicht jedes Mikrogranulats)',
    instructionsForUse: 'Hinweise zur Einnahme',
    instructionsForUseDesc:
      'Nehmen Sie täglich einen Beutel. Sie können ihn pur einnehmen und dazu etwas Wasser trinken, oder auf Joghurt oder Essen streuen.',
    allergyInformation: 'Allergiehinweise',
    allergyInformationDesc:
      'Dieses Produkt enthält keine der häufigsten Allergene. Personen mit Allergien oder Unverträglichkeiten sollten vor der Verwendung ihren Arzt konsultieren',
    warnings: 'Warnhinweise',
    warningsDesc:
      'Nahrungsergänzungsmittel sind kein Ersatz für eine ausgewogene und abwechslungsreiche Ernährung und eine gesunde Lebensweise. Die empfohlene Tagesdosis darf nicht überschritten werden. Außerhalb der Reichweite von kleinen Kindern aufbewahren. Bei Schwangerschaft, Stillzeit, Krankheiten oder Medikamenteneinnahme vor der Verwendung einen Arzt konsultieren.',
    storageInstructions: 'Aufbewahrungshinweise',
    storageInstructionsDesc: 'Kühl und trocken lagern. Vor direkter Sonneneinstrahlung und Wärme schützen',
    bestBeforeDate: 'Mindesthaltbarkeitsdatum',
    manufacturerInformation: 'Herstellerinformationen',
    countryOfManufacture: 'Herstellungsland',
    countryOfManufactureDesc: 'Hergestellt in Deutschland',
    customerService: 'Kundenservice',
    customerServiceDesc: 'Kontaktieren Sie uns unter {0}',
    batchNumber: 'Chargennummer',
    ingredient: 'Inhaltsstoff',
    amountPerB: 'Menge pro B.',
    amountPerBag: 'Menge pro Beutel',
    referenceQuantity: 'Referenzmenge',
    energy: 'Energie',
    fat: 'Fett',
    saturatedFattyAcids: 'Gesättigte Fettsäuren',
    carbohydrates: 'Kohlenhydrate',
    sugar: 'Zucker',
    protein: 'Eiweiß',
    salt: 'Salz',
    nutritionalValues: 'NÄHRWERTE PRO BEUTEL',
    nutritionalInfo: 'NÄHRWERTTABELLE',
    nutrientAmountNrv: '(Nährstoff • Menge • % NRV)',
  },
};
